import { render, staticRenderFns } from "./BreadcrumbNew.vue?vue&type=template&id=02831ed5&"
import script from "./BreadcrumbNew.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports